var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.219,
    height: 38.073,
    viewBox: "0 0 41.219 38.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67401",
    "data-name": "Group 67401",
    transform: "translate(16993.609 -3434.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61856",
    "data-name": "Group 61856",
    transform: "translate(-16993.111 3435.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61855",
    "data-name": "Group 61855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M18695.543-4110.526h-17.789a3.094,3.094,0,0,1-2.58-1.351,3.1,3.1,0,0,1-.359-2.895l5.447-14.521a3.147,3.147,0,0,1,2.939-2.039h27.1a3.1,3.1,0,0,1,2.219.921,3.135,3.135,0,0,1,.922,2.146v.146a3.228,3.228,0,0,1-.2,1.033l-2.7,7.2a8.963,8.963,0,0,0-2.937-2.106,8.942,8.942,0,0,0-3.662-.776,9.01,9.01,0,0,0-9,9,8.975,8.975,0,0,0,.6,3.234Zm-20.912-11.323a1.36,1.36,0,0,1-1.408-1.4v-17.945a3.146,3.146,0,0,1,3.141-3.142h7.256a3.148,3.148,0,0,1,2.227.92l3.354,3.363a3.143,3.143,0,0,0,2.227.92h13.074a2.533,2.533,0,0,1,2.531,2.527,2.685,2.685,0,0,1-2.682,2.682h-23.406a3.163,3.163,0,0,0-1.967.689,3.152,3.152,0,0,0-1.1,1.767l-1.893,8.524A1.354,1.354,0,0,1,18674.631-4121.849Z",
    transform: "translate(-18673.221 4144.095)",
    fill: "#6720ff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61854",
    "data-name": "Group 61854",
    transform: "translate(-776.279 -470.669)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40008",
    "data-name": "Ellipse 40008",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(800 494)",
    fill: "#6720ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82384",
    "data-name": "Path 82384",
    d: "M-21507.178,4031.407l1.191,1.191,2.82-.659-2.412,4.326,2.711-.548,1.385,1.385",
    transform: "translate(13160.183 -17557.506) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProjects);
export default __webpack_public_path__ + "static/media/active-projects.3e1aab35ed2d49944a2f3852435b2d13.svg";
export { ForwardRef as ReactComponent };